module.exports = __webpack_public_path__ + "img/ba.f92494b7.svg";